export default __webpack_public_path__ + "static/media/chat-sidebar.3125c5be.svg";